import { Observable } from 'rxjs';
import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { File, FileEntry } from '@ionic-native/file/ngx';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'media-modal',
  templateUrl: 'media-modal.html',
  styleUrls: ['./media-modal.scss'],
})
export class MediaModal {
  // Data passed in by componentProps
  @Input() title: string;
  @Input() media: any;

  sliderOpts = {
    zoom: {
      maxRatio: 7,
    },
  };

  constructor(
    private analytics: AnalyticsService,
    private statusBar: StatusBar,
    private http: HttpClient,
    public file: File,
    public modalCtrl: ModalController,
  ) {}

  ionViewDidEnter() {
    this.analytics.trackScreen('MediaModal');
  }

  ngOnInit() {
    console.log('ngOnInit()');
    //console.log( 'selectedCountry    ' + this.selectedCountry );
    this.statusBar.styleLightContent();
  }

  dismiss() {
    this.statusBar.styleDefault();
    this.modalCtrl.dismiss();
  }

  download(url): Promise<{ fileEntry: FileEntry; type: string }> {
    return new Promise((resolve, reject) => {
      const d = Date.now();
      const videoFileName = `${d}`;
      // Get the file from the given URL argument. Note responseType is set to 'blob'.
      // It can also be set to 'arraybuffer', but response.body will be of different
      // type and needs to be handled slightly differently.
      this.http
        .get(url, {
          observe: 'response',
          responseType: 'blob',
        })
        .subscribe(
          (response) => {
            // Create /Download folder if it doesn't exist
            this.file
              .createDir(this.file.externalRootDirectory, 'Download', true)
              .then((de) => {
                // Write the downloaded Blob as the file. Note that the file will
                // be overwritten if it already exists!
                this.file
                  .writeFile(de.toURL(), videoFileName, response.body, {
                    replace: true,
                  })
                  .then((fe) => {
                    // All went well, resolve the Promise.
                    return resolve({
                      fileEntry: fe, // FileEntry instance
                      type: response.body.type, // Content-Type for the file
                    });
                  })
                  .catch((err) => {
                    // writeFile failed
                    reject(err);
                  });
              })
              .catch((err) => {
                // createDir failed
                reject(err);
              });
          },
          (err) => {
            // Download failed
            reject(err);
          },
        );
    });
  }
}
